/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationPurgeCounts } from './OrganizationPurgeCounts';
import {
    OrganizationPurgeCountsFromJSON,
    OrganizationPurgeCountsFromJSONTyped,
    OrganizationPurgeCountsToJSON,
    OrganizationPurgeCountsToJSONTyped,
} from './OrganizationPurgeCounts';

/**
 * What a purge deleted; user accounts are never deleted.
 * @export
 * @interface OrganizationPurgeResult
 */
export interface OrganizationPurgeResult {
    /**
     * 
     * @type {OrganizationPurgeCounts}
     * @memberof OrganizationPurgeResult
     */
    counts: OrganizationPurgeCounts;
}

/**
 * Check if a given object implements the OrganizationPurgeResult interface.
 */
export function instanceOfOrganizationPurgeResult(value: object): value is OrganizationPurgeResult {
    if (!('counts' in value) || value['counts'] === undefined) return false;
    return true;
}

export function OrganizationPurgeResultFromJSON(json: any): OrganizationPurgeResult {
    return OrganizationPurgeResultFromJSONTyped(json, false);
}

export function OrganizationPurgeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationPurgeResult {
    if (json == null) {
        return json;
    }
    return {
        
        'counts': OrganizationPurgeCountsFromJSON(json['counts']),
    };
}

export function OrganizationPurgeResultToJSON(json: any): OrganizationPurgeResult {
    return OrganizationPurgeResultToJSONTyped(json, false);
}

export function OrganizationPurgeResultToJSONTyped(value?: OrganizationPurgeResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counts': OrganizationPurgeCountsToJSON(value['counts']),
    };
}

